[
  {
    "name": "Soldador Azul",
    "info": "Guante de carnaza de res con tratamiento a base de aceite, diseñado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo Kevlar que ofrecen alta resistencia al calor. Incluye refuerzo en la palma para mayor durabilidad.",
    "specs": {
      "Material": "Carnaza de res",
      "Tratamiento": "A base de aceite",
      "Forro": "Fieltro blanco (calibre 100–120)",
      "Costuras": "Hilo Kevlar",
      "Refuerzo": "Palma reforzada",
      "Longitud": "14 pulgadas"
    },
    "category": "soldadura",
    "imgs": ["Soldador_azul_2.webp", "Soldador_azul_3.webp", "Soldador_azul_par.webp"],
    "materials": ["carnaza"],
    "colors": { "tag": "color", "values": ["azul"] }
  },
  {
    "name": "Soldador Rojo",
    "info": "Guante de carnaza de res con tratamiento a base de aceite, diseñado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo Kevlar que ofrecen alta resistencia al calor.",
    "specs": {
      "Material": "Carnaza de res",
      "Tratamiento": "A base de aceite",
      "Forro": "Fieltro blanco (calibre 100–120)",
      "Costuras": "Hilo Kevlar",
      "Longitud": "14 pulgadas"
    },
    "category": "soldadura",
    "imgs": ["Soldador_rojo.webp", "Soldador_rojo_2.webp", "Soldador_rojo_3.webp", "Soldador_rojo_par.webp"],
    "materials": ["carnaza"],
    "colors": { "tag": "color", "values": ["rojo"] }
  },
  {
    "name": "Soldador Gris",
    "info": "Guante de carnaza de res con tratamiento a base de aceite, diseñado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo de resistencia estándar.",
    "specs": {
      "Material": "Carnaza de res",
      "Tratamiento": "A base de aceite",
      "Forro": "Fieltro blanco (calibre 100–120)",
      "Costuras": "Hilo estándar",
      "Longitud": "14 pulgadas"
    },
    "category": "soldadura",
    "imgs": ["Soldador_gris.webp", "Soldador_gris_2.webp", "Soldador_gris_3.webp", "Soldador_gris_par.webp"],
    "materials": ["carnaza"],
    "colors": { "tag": "color", "values": ["gris"] }
  },
  {
    "name": "Argonero de piel",
    "info": "Guante fabricado en piel de res de alta calidad, diseñado para ofrecer excelente durabilidad y comodidad. Cuenta con tira ajustable con broche que brinda un ajuste seguro. Incorpora bies rojo en el puño para mayor refuerzo.",
    "specs": {
      "Material": "Piel de res",
      "Diseño": "Argonero",
      "Ajuste": "Tira ajustable con broche",
      "Acabado": "Bies rojo en puño",
      "Largo": "24 cm",
      "Ancho": "13 cm"
    },
    "category": "argon",
    "materials": ["piel"],
    "imgs": ["Argonero_de_piel.webp", "Argonero_de_piel_2.webp", "Argonero_de_piel_3.webp", "Argonero_de_piel_4.webp"],
    "colors": { "tag": "color", "values": ["amarillo natural"] }
  },
  {
    "name": "Argonero elástico",
    "info": "Guante fabricado en piel de res de alta calidad, diseñado para ofrecer excelente durabilidad y comodidad. Cuenta con elástico en la muñeca que brinda un ajuste seguro y cómodo. Incorpora bies rojo en el puño para mayor refuerzo.",
    "specs": {
      "Material": "Piel de res",
      "Diseño": "Argonero",
      "Ajuste": "Elástico en muñeca",
      "Acabado": "Bies rojo en puño",
      "Largo": "24 cm",
      "Ancho": "13 cm"
    },
    "category": "argon",
    "materials": ["piel"],
    "imgs": ["Argonero_elastico.webp", "Argonero_elastico_2.webp"],
    "colors": { "tag": "color", "values": ["amarillo natural"] }
  },
  {
    "name": "Operador",
    "info": "Guante fabricado en piel de res de alta calidad con diseño tipo operador que permite un ajuste ergonómico y acabado suave. Cuenta con tira ajustable con broche para un ajuste seguro y personalizado. Incorpora bies rojo en el puño para mayor refuerzo.",
    "specs": {
      "Material": "Piel de res",
      "Diseño": "Tipo operador",
      "Ajuste": "Tira ajustable con broche",
      "Acabado": "Bies rojo en puño",
      "Largo": "24 cm",
      "Ancho": "13 cm"
    },
    "category": "trabajo-general",
    "materials": ["piel"],
    "imgs": ["Operador.webp", "Operador_2.webp", "Operador_3.webp", "Operador_4.webp"],
    "colors": { "tag": "color", "values": ["amarillo natural"] }
  }
]
